export default {
  definitions: {
    presentation: require('./presentation').default,
  },
}



// WEBPACK FOOTER //
// ./src/content/devdata/addons/socialShare/index.js